import { render, staticRenderFns } from "./LogDateTimeWithNote.vue?vue&type=template&id=6880af36&"
import script from "./LogDateTimeWithNote.vue?vue&type=script&lang=js&"
export * from "./LogDateTimeWithNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports